<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <a ref="target" id="target"></a>
    <fieldset
      :disabled="isResumeCoordinated"
      style="border: 0; padding: 0; margin: 0;"
    >
    <div>
      <div v-if="project.UF_VID_BUDGET === 0">
        <div class="content-title content-mb-14">
          18. Бюджет проекта в части расходования средств займа Фонда, тыс. руб.
        </div>
        <BudgetOld></BudgetOld>
      </div>
      <div v-if="project.UF_VID_BUDGET !== 0">
        <Budget2 :project="project" :step="step" />
      </div>

      <div v-if="project.UF_VID_BUDGET === 0">
        <div class="content-title">
          <span v-if="project.UF_VID_BUDGET === 0">19</span
          ><span v-else>20</span>. Другие источники финансирования проекта,
          включая стадию серийного промышленного производства
        </div>
        <div class="row myrow content-mb-42">
          <div class="col-xs-12 mycol">
            <table class="c-indicator content-mb-25 c-indicator-w-100">
              <thead>
                <tr>
                  <th class="tab-wid-550 al-text">Форма финансирования</th>
                  <th class="tab-wid-250">Страна источника финансирования</th>
                  <th class="tab-wid-250">Источник финансирования</th>
                  <th class="tab-wid-122">Год расходования средств</th>
                  <th class="tab-wid-250">Сумма, тыс. руб.</th>
                  <th class="tab-wid-550 al-text">
                    Полученный результат или цели планируемого финансирования
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-for="dc in directory.tree_vid_financing_other_sources_old"
                >
                  <template v-for="child in dc.CHILD">
                    <tr
                      v-bind:key="index"
                      v-for="(item, index) in project.OTHER_SOURCE_FINANCE
                        .items_old"
                      v-if="item.UF_OTHER_SOURCE_ID === child.ID"
                    >
                      <td
                        v-bind:class="{
                          'pd-col-42':
                            child.CODE === 'fond' || child.CODE === 'regfond'
                        }"
                        v-if="isFirstSource(item.UF_OTHER_SOURCE_ID, index)"
                      >
                        {{ child.NAME }}
                      </td>
                      <td v-else style="text-align: right"></td>
                      <td>
                        <input
                          v-model="item.UF_SOURCE"
                          type="text"
                          class="i-main-style"
                          :disabled="$parent.projectDisabled"
                        />
                      </td>
                      <td>
                        <select
                          v-model="item.UF_COUNTRY_ID"
                          class="i-main-style sel-dropdown"
                          :disabled="
                            child.CODE === 'budget' || $parent.projectDisabled
                          "
                        >
                          <option
                            v-for="item in directory.country"
                            v-bind:value="item.ID"
                            v-bind:key="item.ID"
                            v-text="item.NAME"
                          ></option>
                        </select>
                      </td>
                      <td>
                        <input
                          :value="item.UF_YEAR > 0 ? item.UF_YEAR : ''"
                          type="text"
                          class="i-main-style"
                          :disabled="$parent.projectDisabled"
                        />
                      </td>
                      <td>
                        <input
                          :disabled="$parent.projectDisabled"
                          :value="
                            (item.UF_VALUE > 0 ? item.UF_VALUE : '')
                              | toCurrency
                          "
                          type="text"
                          class="i-main-style"
                        />
                      </td>
                      <td>
                        <input
                          :disabled="$parent.projectDisabled"
                          v-model="item.UF_TARGET"
                          type="text"
                          class="i-main-style"
                        />
                      </td>
                    </tr>
                  </template>
                </template>
                <tr class="tr-foot-itog">
                  <td colspan="4" class="pd-col-62">ИТОГО</td>
                  <td>
                    <strong>{{ calcSourceSum() | toCurrency }}</strong>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <textarea
        class="i-main-style t-dop-style i-wid-50"
        v-model="project.UF_INVESTOR_CONFIRM"
        :disabled="$parent.projectDisabled"
        style="height: 100px"
      ></textarea>
    </div>

    <div class="content-title content-mb-14">
      <span v-if="project.UF_VID_BUDGET === 0">20</span><span v-else>20</span>.
      Предполагаемое обеспечение по возврату займа
    </div>
    <CashBack></CashBack>
    </fieldset>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import CashBack from "@/components/project/form/partial/CashBack";
import BudgetOld from "@/components/project/form/partial/BudgetOld";
import Budget2 from "@/components/project/form/partial/Budget2";

export default {
  name: "step3",
  components: { Budget2, BudgetOld, CashBack },
  props: ["step"],
  data() {
    return {
      loaded: false,
      h16tooltipShow: false,
      h16tooltip:
        "<img src='https://lkbe.frprf.ru//images/project/p15_info.png' />"
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_DIRECTORIES, [
      "tree/vid_financing_other_sources_old",
      "program_fin_support"
    ]);

    if (typeof this.project.OTHER_SOURCE_FINANCE.items_old === "undefined") {
      this.project.OTHER_SOURCE_FINANCE.UF_OTHER_SOURCE_ID = [];
      this.project.OTHER_SOURCE_FINANCE.items_old = [];
    }
  },
  created() {
    this.$store.dispatch(FETCH_DIRECTORY, ["country"]).then(() => {
      this.project.OTHER_SOURCE_FINANCE.UF_OTHER_SOURCE_ID.forEach(function(
        sourceId
      ) {
        let n = false;
        this.project.OTHER_SOURCE_FINANCE.items_old.forEach(function(item) {
          if (sourceId == item.UF_OTHER_SOURCE_ID) {
            n = true;
          }
        }, this);
        if (!n) {
          this.project.OTHER_SOURCE_FINANCE.items_old.push({
            UF_OTHER_SOURCE_ID: sourceId,
            UF_PROJECT_ID: this.project.ID,
            UF_SOURCE: "",
            UF_TARGET: "",
            UF_VALUE: "",
            UF_YEAR: ""
          });
        }
      },
      this);
    }, this);

    this.loaded = true;
  },
  methods: {
    isFirstSource(sourceId, index) {
      let sd = null;
      this.project.OTHER_SOURCE_FINANCE.items_old.forEach(function(item, k) {
        if (sourceId == item.UF_OTHER_SOURCE_ID && sd === null) {
          sd = k;
        }
      }, this);
      return sd === index;
    },
    calcSourceSum() {
      let sum = 0;
      this.project.OTHER_SOURCE_FINANCE.items_old.forEach(function(item) {
        let s = parseInt(item.UF_VALUE);
        if (s > 0) {
          sum += s;
        }
      }, this);
      return sum;
    }
  },
  computed: {
    isResumeCoordinated() {
      const list = this.project && this.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          el.UF_TYPE_PAGE === "rezume_10_01" &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    },
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
